import type { Site, SiteWithCanonicalUrl } from "schemas/generated/sites";

import { siteSchema, siteWithCanonicalUrlSchema } from "schemas/sites";

type RequestOptions = {
  method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
  path: string;
  query?: Record<string, string | number | undefined>;
  body?: unknown;
};

export function createSitesClient({
  request,
}: {
  request: <ResponseType>(options: RequestOptions) => Promise<ResponseType>;
}) {
  return {
    find: async (input: {
      projectId: string;
    }): Promise<SiteWithCanonicalUrl[]> => {
      const result = await request<{ sites: unknown }>({
        method: "GET",
        path: "/api/v1/sites",
        query: { projectId: input.projectId },
      });
      // Parse at the gateway boundary: coerces wire-format date strings into real
      // `Date`s (the schema uses z.coerce.date) so the `Site` type isn't a lie.
      return siteWithCanonicalUrlSchema.array().parse(result.sites);
    },
    update: async (input: { siteId: string; name: string }): Promise<Site> => {
      const result = await request<{ site: unknown }>({
        method: "PATCH",
        path: `/api/v1/sites/${encodeURIComponent(input.siteId)}`,
        body: { name: input.name },
      });
      return siteSchema.parse(result.site);
    },
  };
}

export type SitesClient = ReturnType<typeof createSitesClient>;
